<template>
  <tr class="rate-row">
    <td>
      {{ rate.AccountType.dropdownLabel }}
    </td>
    <td>
      <span class="badge" :class="randomLabel">{{ rate.CarClass.name }}</span>
    </td>
    <td>
      <div class="text-center">
        {{ rate.hourlyRate | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ rate.dailyRate | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ rate.overnightRate | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ rate.weekendRate | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ rate.includeKms }}km
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ rate.perKmCost | to_dollar_amount }}
      </div>
    </td>
    <td>
      <router-link v-if="isFinanceAdmin" class="btn btn-sm btn-primary"
      :to="'/membership/rates/vehicles/edit/' + rate.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button v-else disabled class="btn btn-sm btn-primary">
        <span class="fa fa-edit fa-fw"></span> Edit
      </button>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import { randomLabel } from '@/util/helpers'

export default {
  name: 'RateRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    rate () {
      return {
        CarClass: {
          name: ''
        },
        AccountType: {
          name: ''
        },
        ...this.object
      }
    },
    ...mapGetters([
      'isFinanceAdmin'
    ]),
    randomLabel () {
      if (this.rate.CarClass) {
        return randomLabel(this.rate.CarClass.name, 'badge')
      } else {
        return {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Rate.vue